<template>
  <div class="d-flex flex1">
    <CustomScenarioChart :period="customChartPeriod" category="age" />
  </div>
</template>

<script>
import CustomScenarioChart from '../../Charts/CustomScenarioChart.vue';
import helpers from '../../../helpers';

export default {
  components: {
    CustomScenarioChart
  },
  computed: {
    customChartPeriod() {
      return (
        this.$store.state.scenarioData.currentScenarioData.finalValues.otherValues
          .maxFutureAgeDiff - 1
      );
    }
  },
  methods: { maxPeriod: helpers.getMaxPeriod }
};
</script>

<style scoped></style>
